import React from 'react'
import './loader.css'
import { Spinner } from 'react-bootstrap'
import { Backdrop } from '@mui/material'

/**
 * @component Loader
 * component to implement loading during APi calls 
 * or any other operation that takes some time
 * @param {loader} props 
 */
const Loader = (props) => {
   
    return (
        <div >
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={props.loader}
            >
                <div>
                    <Spinner animation="border" />
                </div>
                <div className="message">Loading</div>
            </Backdrop>
        </div>
    )
}

export default Loader
